export default __webpack_public_path__ + "static/media/mail_ico.8ad5b829.svg";